import { useEffect, useState } from 'react';
import { apiRequests } from '../../../shared/api/apiRequests';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UploadPicture } from '../../UploadPicture/index.js';
import { LanguageOptions } from '../../../entities/LanguageOptions/index.js';
import '../../../Pages/Team/Team.css';

export const CreateTeamMemberForm = () => {
  const [saving, setSaving] = useState(false);
  const [mainImage, setMainImage] = useState(null);
  const [form, setForm] = useState({
    name: '',
    surname: '',
    position: '',
    TeamGroupId: null,
    mainLanguageId: 1,
    shortExpierence: '',
    quote: '',
    SEOMetatags: {
      Title: '',
      Description: '',
      Keywords: '',
    },
    DetailContent: {
      Items: [],
    },
  });
  const { structureId, id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setForm((prev) => ({ ...prev, TeamGroupId: Number(id) }));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.surname.trim()) {
      toast.error('Введите имя и фамилию');
      return;
    }

    setSaving(true);
    try {
      const body = new FormData();
      if (mainImage) {
        body.append('mainImg', mainImage);
      }
      body.append('model', JSON.stringify({ ...form, TeamGroupId: Number(id) }));
      await apiRequests.team.createMember(body);
      toast.success('Участник создан');
      navigate(`/team-structures/${structureId}/group/${id}`);
    } catch {
      toast.error('Ошибка создания');
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => {
    navigate(`/team-structures/${structureId}/group/${id}`);
  };

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={handleBack}>← Назад</button>
          <h1 className="team-title">Новый участник</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="team-form">
        <div className="team-form-section">
          <div className="team-form-row">
            <div className="team-form-field">
              <label>Имя <span className="required">*</span></label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Введите имя"
                className="team-input"
              />
            </div>
            <div className="team-form-field">
              <label>Фамилия <span className="required">*</span></label>
              <input
                type="text"
                value={form.surname}
                onChange={(e) => setForm((prev) => ({ ...prev, surname: e.target.value }))}
                placeholder="Введите фамилию"
                className="team-input"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Должность</label>
              <input
                type="text"
                value={form.position}
                onChange={(e) => setForm((prev) => ({ ...prev, position: e.target.value }))}
                placeholder="UI/UX Designer"
                className="team-input"
              />
            </div>
            <div className="team-form-field">
              <label>Опыт работы</label>
              <input
                type="text"
                value={form.shortExpierence}
                onChange={(e) => setForm((prev) => ({ ...prev, shortExpierence: e.target.value }))}
                placeholder="5 лет"
                className="team-input"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Цитата</label>
              <textarea
                value={form.quote}
                onChange={(e) => setForm((prev) => ({ ...prev, quote: e.target.value }))}
                placeholder="Введите цитату"
                className="team-textarea"
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field" style={{ maxWidth: 200 }}>
              <LanguageOptions
                onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
              />
            </div>
          </div>

          <div className="team-form-row">
            <div className="team-form-field">
              <label>Фото</label>
              <UploadPicture onSelect={setMainImage} entityType="team" />
            </div>
          </div>
        </div>

        <div className="team-form-section" style={{ borderTop: '1px solid #f0f0f0' }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 20, color: '#1a1a1a' }}>SEO настройки</h3>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Title</label>
              <input
                type="text"
                value={form.SEOMetatags.Title}
                onChange={(e) => setForm((prev) => ({ 
                  ...prev, 
                  SEOMetatags: { ...prev.SEOMetatags, Title: e.target.value } 
                }))}
                placeholder="Заголовок для поисковиков"
                className="team-input"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Description</label>
              <textarea
                value={form.SEOMetatags.Description}
                onChange={(e) => setForm((prev) => ({ 
                  ...prev, 
                  SEOMetatags: { ...prev.SEOMetatags, Description: e.target.value } 
                }))}
                placeholder="Описание для поисковиков"
                className="team-textarea"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Keywords</label>
              <input
                type="text"
                value={form.SEOMetatags.Keywords}
                onChange={(e) => setForm((prev) => ({ 
                  ...prev, 
                  SEOMetatags: { ...prev.SEOMetatags, Keywords: e.target.value } 
                }))}
                placeholder="Ключевые слова через запятую"
                className="team-input"
              />
            </div>
          </div>
        </div>

        <div className="team-form-actions">
          <button type="button" className="team-btn-cancel" onClick={handleBack}>
            Отмена
          </button>
          <button type="submit" className="team-btn-submit" disabled={saving}>
            {saving ? 'Создание...' : 'Создать участника'}
          </button>
        </div>
      </form>
    </div>
  );
};
